import React from "react"
import Button from "../Button"
import {
  TicketHeader,
  PriceContainer,
  TrackPriceText,
  TrackPrice,
  Price,
  GrayText,
  TicketContentWrapper,
  PriceColumn,
  PurchaseColumn,
  TicketContentSpecialWrapper,
  SpecialText,
} from "../../styles/ticketList.style"
import TicketListDetail from "./TicketListDetail"
import useDeviceType from "../../utils/useDeviceType"

export default function TicketList({ deepLink, ticket, openDownloadModal }) {
  const deviceType = useDeviceType()

  const isTickethoss = process.env.GATSBY_APP_PLATFORM === "tickethoss"

  const redirectToExternalLink = () => {
    const externalLink = deepLink ? deepLink : process.env.GATSBY_EXTERNAL_URL

    if (deviceType === "android" || deviceType === "ios") {
      window.location.href = externalLink
    } else {
      openDownloadModal()
    }
  }

  return !ticket.is_featured ? (
    <TicketContentWrapper className="Col">
      <iframe
        style={{ display: "none" }}
        height={0}
        width={0}
        id="loader"
        title="loader"
      ></iframe>
      <TicketHeader className="Col">{ticket.name}</TicketHeader>
      <TicketListDetail content={ticket.description} />
      <PriceContainer className="Row">
        <PriceColumn>
          {ticket.track_price ? (
            <TrackPriceText>
              {`at Track Price:  `}
              <TrackPrice>
                ${(Math.round(ticket.track_price * 100) / 100).toFixed(2)}
              </TrackPrice>
            </TrackPriceText>
          ) : null}

          <Price>${(Math.round(ticket.price * 100) / 100).toFixed(2)}</Price>

          {ticket.fee && ticket.fee !== 0 && (
            <GrayText>
              +${(Math.round(ticket.fee * 100) / 100).toFixed(2)}{" "}
              {isTickethoss ? "Ticket Fee" : "Pass Fee"} & Order Processing Fee`
            </GrayText>
          )}
        </PriceColumn>
        <PurchaseColumn className="Col">
          <Button
            text={ticket.is_soldout ? "Sold Out" : "Purchase"}
            style={{
              minWidth: 155,
              maxHeight: 56,
              fontSize: "1.5em",
              lineHeight: "34px",
            }}
            disabled={ticket.is_soldout}
            onClick={redirectToExternalLink}
          />
        </PurchaseColumn>
      </PriceContainer>
    </TicketContentWrapper>
  ) : (
    <TicketContentSpecialWrapper className="Col">
      {ticket.featured_text && <SpecialText>SUPER SPECIAL</SpecialText>}
      <TicketHeader className="Col" is_featured={ticket.is_featured}>
        {ticket.name}
      </TicketHeader>
      <TicketListDetail content={ticket.description} />
      <PriceContainer className="Row">
        <PriceColumn>
          <TrackPriceText is_featured={ticket.is_featured}>
            at Track Price:{" "}
            <TrackPrice>
              ${(Math.round(ticket.track_price * 100) / 100).toFixed(2)}
            </TrackPrice>
          </TrackPriceText>
          <Price is_featured={ticket.is_featured}>
            ${(Math.round(ticket.price * 100) / 100).toFixed(2)}
          </Price>
          <GrayText>
            +${(Math.round(ticket.fee * 100) / 100).toFixed(2)} Fee
          </GrayText>
        </PriceColumn>
        <PurchaseColumn className="Col">
          {!ticket.is_soldout && (
            <GrayText is_featured={ticket.is_featured}>To Purchase</GrayText>
          )}
          <Button
            text={ticket.is_soldout ? "Sold Out" : "Get Ticket"}
            style={{
              minWidth: 155,
              maxHeight: 56,
              fontSize: "1.5em",
              lineHeight: "34px",
            }}
            disabled={ticket.is_soldout}
            onClick={redirectToExternalLink}
          />
        </PurchaseColumn>
      </PriceContainer>
    </TicketContentSpecialWrapper>
  )
}
